import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * Loading placeholder shaped like the real OrderCard (identifiers, promise time,
 * meta line, one primary action, two secondaries) so data arrival never shifts
 * the layout. Kept next to OrderCard so the two stay in sync.
 */
export function OrderCardSkeleton() {
  return (
    <Card className="bg-card rounded-radius-card shadow-sm" aria-hidden="true">
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0 flex-1 space-y-2">
            <Skeleton className="h-6 w-32" />
            <Skeleton className="h-5 w-40" />
          </div>
          <div className="flex flex-none flex-col items-end gap-1.5">
            <Skeleton className="h-3 w-14" />
            <Skeleton className="h-5 w-20" />
          </div>
        </div>
        <div className="mt-3 flex flex-wrap gap-2">
          <Skeleton className="h-3 w-16" />
          <Skeleton className="h-3 w-20" />
          <Skeleton className="h-3 w-24" />
        </div>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-center">
          <Skeleton className="h-12 sm:h-11 w-full sm:w-44 rounded-md" />
          <div className="grid grid-cols-2 gap-2 sm:flex sm:gap-2">
            <Skeleton className="h-11 w-full sm:w-24 rounded-md" />
            <Skeleton className="h-11 w-full sm:w-28 rounded-md" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default OrderCardSkeleton;
